export const algebra2TestOH = [
  {
    id: 1,
    question: "Which function represents exponential decay?",
    options: [
      "f(x) = 3(0.8)^x",
      "f(x) = 3(1.2)^x",
      "f(x) = 3x²",
      "f(x) = 3x + 2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recall exponential function form:\nf(x) = a(b)^x\n\nStep 2: Identify decay vs. growth:\n- If 0 < b < 1: exponential decay\n- If b > 1: exponential growth\n\nStep 3: Check each option:\nA) f(x) = 3(0.8)^x: b = 0.8, and 0 < 0.8 < 1 → decay ✓\nB) f(x) = 3(1.2)^x: b = 1.2 > 1 → growth ✗\nC) f(x) = 3x²: quadratic, not exponential ✗\nD) f(x) = 3x + 2: linear, not exponential ✗\n\nAnswer: A",
    points: 2
  },
  {
    id: 2,
    question: "Simplify: (4x²y³)(3x³y²)",
    options: [
      "12x⁵y⁵",
      "12x⁶y⁶",
      "7x⁵y⁵",
      "12x⁵y⁶"
    ],
    correctAnswer: 0,
    solution: "Step 1: Multiply the coefficients:\n4 × 3 = 12\n\nStep 2: Use the product rule for exponents (x^m · x^n = x^(m+n)):\nFor x: x² · x³ = x^(2+3) = x⁵\nFor y: y³ · y² = y^(3+2) = y⁵\n\nStep 3: Combine:\n12x⁵y⁵\n\nAnswer: A",
    points: 2
  },
  {
    id: 3,
    question: "What is the solution to the equation 3^(x-1) = 27?",
    options: [
      "x = 4",
      "x = 3",
      "x = 9",
      "x = 2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express 27 as a power of 3:\n27 = 3³\n\nStep 2: Rewrite the equation:\n3^(x-1) = 3³\n\nStep 3: Since bases are equal, set exponents equal:\nx - 1 = 3\n\nStep 4: Solve for x:\nx = 3 + 1 = 4\n\nStep 5: Check: 3^(4-1) = 3³ = 27 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 4,
    question: "Find the 10th term of the geometric sequence: 2, 6, 18, 54, ...",
    options: [
      "39,366",
      "13,122",
      "59,049",
      "19,683"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify first term and common ratio:\na₁ = 2\nr = 6/2 = 3\n\nStep 2: Use the geometric sequence formula:\naₙ = a₁ · r^(n-1)\n\nStep 3: Find the 10th term (n = 10):\na₁₀ = 2 · 3^(10-1)\n    = 2 · 3⁹\n    = 2 · 19,683\n    = 39,366\n\nStep 4: Verify the pattern:\n3⁹ = 19,683\n2 × 19,683 = 39,366 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 5,
    question: "Solve for x: log₅(x) + log₅(4) = log₅(20)",
    options: [
      "x = 5",
      "x = 4",
      "x = 16",
      "x = 80"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the logarithm product rule:\nlog_b(m) + log_b(n) = log_b(mn)\n\nStep 2: Apply to the left side:\nlog₅(x) + log₅(4) = log₅(4x)\n\nStep 3: Set equal to the right side:\nlog₅(4x) = log₅(20)\n\nStep 4: Since the logarithms are equal with the same base:\n4x = 20\n\nStep 5: Solve for x:\nx = 20/4 = 5\n\nStep 6: Check: log₅(5) + log₅(4) = log₅(20)\n1 + log₅(4) = log₅(20) ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 6,
    question: "What is the range of f(x) = 2^x?",
    options: [
      "y > 0",
      "y ≥ 0",
      "All real numbers",
      "y < 0"
    ],
    correctAnswer: 0,
    solution: "Step 1: Analyze the exponential function f(x) = 2^x:\n- The base is 2 (positive)\n- Exponential functions with positive bases are always positive\n\nStep 2: Check behavior:\n- As x → -∞, 2^x → 0⁺ (approaches 0 from above)\n- As x → ∞, 2^x → ∞\n- 2^x never equals 0 or becomes negative\n\nStep 3: The function takes all positive values:\nRange: y > 0 or (0, ∞) in interval notation\n\nNote: y ≥ 0 would be incorrect because 2^x never actually equals 0.\n\nAnswer: A",
    points: 2
  },
  {
    id: 7,
    question: "Simplify: √(50x³y⁴)",
    options: [
      "5xy²√(2x)",
      "5x²y²√2",
      "25xy²√(2x)",
      "5xy√(2x)"
    ],
    correctAnswer: 0,
    solution: "Step 1: Factor the radicand into perfect squares:\n√(50x³y⁴) = √(25 · 2 · x² · x · y⁴)\n\nStep 2: Separate perfect squares:\n= √(25) · √(x²) · √(y⁴) · √(2x)\n\nStep 3: Simplify each perfect square:\n√(25) = 5\n√(x²) = x\n√(y⁴) = y²\n\nStep 4: Combine:\n= 5 · x · y² · √(2x)\n= 5xy²√(2x)\n\nAnswer: A",
    points: 2
  },
  {
    id: 8,
    question: "What is the probability of rolling a sum of 7 with two standard dice?",
    options: [
      "1/6",
      "1/12",
      "7/36",
      "1/36"
    ],
    correctAnswer: 0,
    solution: "Step 1: Find total possible outcomes:\nEach die has 6 faces, so total outcomes = 6 × 6 = 36\n\nStep 2: List all ways to get a sum of 7:\n(1,6), (2,5), (3,4), (4,3), (5,2), (6,1)\nCount: 6 favorable outcomes\n\nStep 3: Calculate probability:\nP(sum = 7) = favorable outcomes / total outcomes\n            = 6/36\n            = 1/6\n\nStep 4: Verify:\n6/36 = 1/6 ≈ 0.167 or about 16.7%\n\nAnswer: A",
    points: 2
  },
  {
    id: 9,
    question: "Factor completely: x⁴ - 16",
    options: [
      "(x² + 4)(x + 2)(x - 2)",
      "(x² - 4)(x² + 4)",
      "(x + 2)(x - 2)(x + 2)(x - 2)",
      "(x - 2)⁴"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recognize as difference of squares:\nx⁴ - 16 = (x²)² - 4²\n\nStep 2: Apply difference of squares formula (a² - b² = (a+b)(a-b)):\n= (x² + 4)(x² - 4)\n\nStep 3: Check if x² - 4 can be factored further:\nx² - 4 = (x + 2)(x - 2) ✓ (difference of squares)\n\nStep 4: Check if x² + 4 can be factored:\nx² + 4 is a sum of squares, which doesn't factor over real numbers ✗\n\nStep 5: Complete factorization:\n(x² + 4)(x + 2)(x - 2)\n\nAnswer: A",
    points: 2
  },
  {
    id: 10,
    question: "If f(x) = x² - 3 and g(x) = 2x + 1, find (g ∘ f)(2).",
    options: [
      "3",
      "5",
      "7",
      "1"
    ],
    correctAnswer: 0,
    solution: "Step 1: Understand composition:\n(g ∘ f)(2) = g(f(2))\n\nStep 2: Find f(2):\nf(2) = 2² - 3 = 4 - 3 = 1\n\nStep 3: Find g(1):\ng(1) = 2(1) + 1 = 2 + 1 = 3\n\nStep 4: Therefore:\n(g ∘ f)(2) = 3\n\nAlternative method:\ng(f(x)) = g(x² - 3) = 2(x² - 3) + 1 = 2x² - 6 + 1 = 2x² - 5\ng(f(2)) = 2(2²) - 5 = 8 - 5 = 3 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 11,
    question: "Solve: |3x + 2| < 7",
    options: [
      "-3 < x < 5/3",
      "x < -3 or x > 5/3",
      "-5/3 < x < 3",
      "x < 5/3"
    ],
    correctAnswer: 0,
    solution: "Step 1: Rewrite absolute value inequality:\n|3x + 2| < 7 means -7 < 3x + 2 < 7\n\nStep 2: Solve the compound inequality:\n-7 < 3x + 2  AND  3x + 2 < 7\n\nStep 3: Solve the left inequality:\n-7 < 3x + 2\n-9 < 3x\n-3 < x\n\nStep 4: Solve the right inequality:\n3x + 2 < 7\n3x < 5\nx < 5/3\n\nStep 5: Combine:\n-3 < x < 5/3\n\nStep 6: Check a value in the interval, say x = 0:\n|3(0) + 2| = |2| = 2 < 7 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 12,
    question: "What is the vertex form of y = x² + 8x + 10?",
    options: [
      "y = (x + 4)² - 6",
      "y = (x + 4)² + 6",
      "y = (x - 4)² - 6",
      "y = (x + 8)² + 10"
    ],
    correctAnswer: 0,
    solution: "Step 1: Complete the square:\ny = x² + 8x + 10\n\nStep 2: Take half of the x coefficient and square it:\n(8/2)² = 4² = 16\n\nStep 3: Add and subtract 16:\ny = (x² + 8x + 16) + 10 - 16\n\nStep 4: Factor the perfect square trinomial:\ny = (x + 4)² - 6\n\nStep 5: Verify by expanding:\n(x + 4)² - 6 = x² + 8x + 16 - 6 = x² + 8x + 10 ✓\n\nVertex: (-4, -6)\n\nAnswer: A",
    points: 2
  },
  {
    id: 13,
    question: "Simplify: (2 - 5i) - (3 + 2i)",
    options: [
      "-1 - 7i",
      "-1 + 7i",
      "5 - 7i",
      "-1 - 3i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Distribute the negative sign:\n(2 - 5i) - 3 - 2i\n\nStep 2: Combine real parts:\n2 - 3 = -1\n\nStep 3: Combine imaginary parts:\n-5i - 2i = -7i\n\nStep 4: Write in standard form a + bi:\n-1 - 7i\n\nAnswer: A",
    points: 2
  },
  {
    id: 14,
    question: "What is the sum of the first 8 terms of the arithmetic sequence: 5, 9, 13, 17, ...?",
    options: [
      "152",
      "144",
      "160",
      "136"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify first term and common difference:\na₁ = 5\nd = 9 - 5 = 4\n\nStep 2: Find the 8th term:\na₈ = a₁ + (n - 1)d = 5 + (8 - 1)(4) = 5 + 28 = 33\n\nStep 3: Use the arithmetic series sum formula:\nSₙ = n(a₁ + aₙ)/2\n\nStep 4: Calculate:\nS₈ = 8(5 + 33)/2 = 8(38)/2 = 304/2 = 152\n\nAlternative formula: Sₙ = n[2a₁ + (n-1)d]/2\nS₈ = 8[2(5) + (8-1)(4)]/2 = 8[10 + 28]/2 = 8(38)/2 = 152 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 15,
    question: "Solve: 2x² - 5x - 3 = 0",
    options: [
      "x = 3 or x = -1/2",
      "x = -3 or x = 1/2",
      "x = 3 or x = 1/2",
      "x = -3 or x = -1/2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Factor the quadratic:\n2x² - 5x - 3 = 0\n\nStep 2: Find factors of ac = 2(-3) = -6 that add to b = -5:\nFactors: -6 and 1 (since -6 + 1 = -5)\n\nStep 3: Rewrite and factor by grouping:\n2x² - 6x + x - 3 = 0\n2x(x - 3) + 1(x - 3) = 0\n(2x + 1)(x - 3) = 0\n\nStep 4: Apply zero product property:\n2x + 1 = 0  OR  x - 3 = 0\n2x = -1        x = 3\nx = -1/2\n\nStep 5: Check both solutions:\n2(3)² - 5(3) - 3 = 18 - 15 - 3 = 0 ✓\n2(-1/2)² - 5(-1/2) - 3 = 1/2 + 5/2 - 3 = 0 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 16,
    question: "What is the equation of the axis of symmetry for y = -2x² + 12x - 5?",
    options: [
      "x = 3",
      "x = -3",
      "x = 6",
      "x = 12"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the axis of symmetry formula:\nFor y = ax² + bx + c, axis of symmetry is x = -b/(2a)\n\nStep 2: Identify a and b:\na = -2\nb = 12\n\nStep 3: Calculate:\nx = -12/(2(-2)) = -12/(-4) = 3\n\nStep 4: The axis of symmetry is x = 3\n\nNote: This is also the x-coordinate of the vertex.\n\nAnswer: A",
    points: 2
  },
  {
    id: 17,
    question: "Simplify: (x² - 4)/(x² + 4x + 4)",
    options: [
      "(x - 2)/(x + 2)",
      "(x + 2)/(x - 2)",
      "(x - 2)²/(x + 2)²",
      "1"
    ],
    correctAnswer: 0,
    solution: "Step 1: Factor the numerator (difference of squares):\nx² - 4 = (x + 2)(x - 2)\n\nStep 2: Factor the denominator (perfect square trinomial):\nx² + 4x + 4 = (x + 2)²\n\nStep 3: Write with factored forms:\n[(x + 2)(x - 2)] / [(x + 2)(x + 2)]\n\nStep 4: Cancel common factor (x + 2):\n(x - 2)/(x + 2)\n\nNote: x ≠ -2 (restriction from original denominator)\n\nAnswer: A",
    points: 2
  },
  {
    id: 18,
    question: "If log₂(x) = 5, what is x?",
    options: [
      "32",
      "10",
      "25",
      "64"
    ],
    correctAnswer: 0,
    solution: "Step 1: Convert from logarithmic to exponential form:\nlog₂(x) = 5 means 2⁵ = x\n\nStep 2: Evaluate 2⁵:\n2⁵ = 2 × 2 × 2 × 2 × 2 = 32\n\nStep 3: Therefore:\nx = 32\n\nStep 4: Check: log₂(32) = log₂(2⁵) = 5 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 19,
    question: "What is the domain of f(x) = 1/(x - 5)?",
    options: [
      "All real numbers except x = 5",
      "All real numbers except x = -5",
      "x > 5",
      "All real numbers"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify restrictions:\nThe function is undefined when the denominator equals zero.\n\nStep 2: Set denominator equal to zero:\nx - 5 = 0\nx = 5\n\nStep 3: The function is defined for all real numbers except x = 5.\n\nStep 4: Domain in interval notation:\n(-∞, 5) ∪ (5, ∞)\n\nAnswer: A",
    points: 2
  },
  {
    id: 20,
    question: "Evaluate: 8^(2/3)",
    options: [
      "4",
      "2",
      "16",
      "8"
    ],
    correctAnswer: 0,
    solution: "Step 1: Rewrite using radical notation:\n8^(2/3) = (∛8)²\n\nStep 2: Find the cube root of 8:\n∛8 = 2 (since 2³ = 8)\n\nStep 3: Square the result:\n2² = 4\n\nAlternative method:\n8^(2/3) = (8²)^(1/3) = 64^(1/3) = ∛64 = 4 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 21,
    question: "Solve the system:\ny = x² - 2\ny = 2x + 1",
    options: [
      "(3, 7) and (-1, -1)",
      "(3, 7) only",
      "(-1, -1) only",
      "No solution"
    ],
    correctAnswer: 0,
    solution: "Step 1: Set the equations equal:\nx² - 2 = 2x + 1\n\nStep 2: Rearrange to standard form:\nx² - 2x - 3 = 0\n\nStep 3: Factor:\n(x - 3)(x + 1) = 0\n\nStep 4: Solve for x:\nx = 3 or x = -1\n\nStep 5: Find corresponding y values using y = 2x + 1:\nFor x = 3: y = 2(3) + 1 = 7 → (3, 7)\nFor x = -1: y = 2(-1) + 1 = -1 → (-1, -1)\n\nStep 6: Verify both in y = x² - 2:\n(3, 7): 7 = 3² - 2 = 9 - 2 = 7 ✓\n(-1, -1): -1 = (-1)² - 2 = 1 - 2 = -1 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 22,
    question: "What is the inverse of f(x) = 2x - 7?",
    options: [
      "f⁻¹(x) = (x + 7)/2",
      "f⁻¹(x) = (x - 7)/2",
      "f⁻¹(x) = 2x + 7",
      "f⁻¹(x) = (2x + 7)/2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Replace f(x) with y:\ny = 2x - 7\n\nStep 2: Swap x and y:\nx = 2y - 7\n\nStep 3: Solve for y:\nx + 7 = 2y\ny = (x + 7)/2\n\nStep 4: Replace y with f⁻¹(x):\nf⁻¹(x) = (x + 7)/2\n\nStep 5: Verify by composition:\nf(f⁻¹(x)) = f((x+7)/2) = 2((x+7)/2) - 7 = (x+7) - 7 = x ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 23,
    question: "Simplify: √(-25) + √(-9)",
    options: [
      "8i",
      "-8i",
      "8",
      "34i"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express each square root in terms of i:\n√(-25) = √(25 · -1) = √25 · √(-1) = 5i\n√(-9) = √(9 · -1) = √9 · √(-1) = 3i\n\nStep 2: Add:\n5i + 3i = 8i\n\nNote: Remember that i = √(-1)\n\nAnswer: A",
    points: 2
  },
  {
    id: 24,
    question: "What is the y-intercept of f(x) = 3(x - 2)² + 5?",
    options: [
      "17",
      "5",
      "-7",
      "11"
    ],
    correctAnswer: 0,
    solution: "Step 1: The y-intercept occurs when x = 0.\n\nStep 2: Substitute x = 0:\nf(0) = 3(0 - 2)² + 5\n\nStep 3: Evaluate:\n= 3(-2)² + 5\n= 3(4) + 5\n= 12 + 5\n= 17\n\nStep 4: The y-intercept is (0, 17), or simply 17.\n\nAnswer: A",
    points: 2
  },
  {
    id: 25,
    question: "Factor: x² + 10x + 25",
    options: [
      "(x + 5)²",
      "(x + 5)(x - 5)",
      "(x - 5)²",
      "(x + 10)(x + 15)"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recognize as a perfect square trinomial:\nPattern: a² + 2ab + b² = (a + b)²\n\nStep 2: Identify a and b:\nx² + 10x + 25\na² = x², so a = x\nb² = 25, so b = 5\n\nStep 3: Check middle term:\n2ab = 2(x)(5) = 10x ✓\n\nStep 4: Factor:\n(x + 5)²\n\nStep 5: Verify by expanding:\n(x + 5)² = x² + 10x + 25 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 26,
    question: "Solve: ln(x) + ln(3) = ln(15)",
    options: [
      "x = 5",
      "x = 12",
      "x = 45",
      "x = 18"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the logarithm product rule:\nln(a) + ln(b) = ln(ab)\n\nStep 2: Apply to the left side:\nln(x) + ln(3) = ln(3x)\n\nStep 3: Set equal to the right side:\nln(3x) = ln(15)\n\nStep 4: Since the natural logarithms are equal:\n3x = 15\n\nStep 5: Solve for x:\nx = 15/3 = 5\n\nStep 6: Check: ln(5) + ln(3) = ln(15) ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 27,
    question: "What is the discriminant of 2x² - 3x + 5 = 0?",
    options: [
      "-31",
      "31",
      "49",
      "-49"
    ],
    correctAnswer: 0,
    solution: "Step 1: Recall the discriminant formula:\nFor ax² + bx + c = 0, discriminant = b² - 4ac\n\nStep 2: Identify a, b, and c:\na = 2, b = -3, c = 5\n\nStep 3: Calculate:\nΔ = b² - 4ac\n  = (-3)² - 4(2)(5)\n  = 9 - 40\n  = -31\n\nStep 4: Interpret:\nSince Δ < 0, the equation has two complex (non-real) solutions.\n\nAnswer: A",
    points: 2
  },
  {
    id: 28,
    question: "Simplify: (x³)⁴",
    options: [
      "x¹²",
      "x⁷",
      "x⁶⁴",
      "x⁸¹"
    ],
    correctAnswer: 0,
    solution: "Step 1: Use the power rule for exponents:\n(x^m)^n = x^(mn)\n\nStep 2: Apply to (x³)⁴:\n(x³)⁴ = x^(3·4) = x¹²\n\nStep 3: Verify by expanding:\n(x³)⁴ = x³ · x³ · x³ · x³ = x^(3+3+3+3) = x¹² ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 29,
    question: "What is the solution to 5^(2x) = 125?",
    options: [
      "x = 3/2",
      "x = 3",
      "x = 2",
      "x = 5/2"
    ],
    correctAnswer: 0,
    solution: "Step 1: Express 125 as a power of 5:\n125 = 5³\n\nStep 2: Rewrite the equation:\n5^(2x) = 5³\n\nStep 3: Since bases are equal, set exponents equal:\n2x = 3\n\nStep 4: Solve for x:\nx = 3/2\n\nStep 5: Check: 5^(2·3/2) = 5³ = 125 ✓\n\nAnswer: A",
    points: 2
  },
  {
    id: 30,
    question: "Find the sum of the infinite geometric series: 8 + 4 + 2 + 1 + ...",
    options: [
      "16",
      "15",
      "8",
      "The series diverges"
    ],
    correctAnswer: 0,
    solution: "Step 1: Identify first term and common ratio:\na₁ = 8\nr = 4/8 = 1/2\n\nStep 2: Check convergence:\nFor convergence, |r| < 1\n|1/2| = 0.5 < 1 ✓ (converges)\n\nStep 3: Use the infinite geometric series formula:\nS = a₁/(1 - r)\n\nStep 4: Calculate:\nS = 8/(1 - 1/2) = 8/(1/2) = 8 × 2 = 16\n\nStep 5: Verify intuitively:\nThe series approaches 16 as more terms are added.\n\nAnswer: A",
    points: 2
  }
];